export default "__VITE_ASSET__a63f4704__"